import { HttpMethod } from '@previo/core'
import { APIPaths } from '~/http/APIPaths'
import Http from '~/http/Http'
import type { ServiceClassifications } from '~/http/invoicing/serviceClassifications/types'

export class ServiceClassificationsAPI extends Http {
  getServiceClassifications = (): Promise<ServiceClassifications> => {
    return this.callAuthWithPropertyAPI<null, ServiceClassifications>(
      HttpMethod.GET,
      {
        path: APIPaths.INVOICING_SERVICE_CLASSIFICATIONS,
      },
      null,
    )
  }
}
